<script lang="ts">
  // Ported from fe/src/lib/components/Avatar.svelte (Svelte 5 runes).
  let {
    src = '',
    alt = '',
    size = 'tashimoto-support-w-8 tashimoto-support-h-8',
  }: { src?: string; alt?: string; size?: string } = $props();

  function getInitials(name: string): string {
    const parts = name.split(' ').filter(Boolean);
    const getLetter = (word: string) => {
      const match = word.match(/[a-zA-Z]/);
      return match ? match[0].toUpperCase() : '';
    };
    if (parts.length >= 2) {
      return `${getLetter(parts[0])}${getLetter(parts[parts.length - 1])}`;
    }
    return getLetter(name);
  }
</script>

<div
  class="{size} tashimoto-support-rounded-full tashimoto-support-overflow-hidden tashimoto-support-border tashimoto-support-border-gray-300 tashimoto-support-bg-gray-200 tashimoto-support-flex tashimoto-support-items-center tashimoto-support-justify-center"
>
  {#if src && src !== '/placeholder.svg'}
    <img {src} {alt} class="tashimoto-support-w-full tashimoto-support-h-full tashimoto-support-object-cover" />
  {:else}
    <span
      class="tashimoto-support-text-gray-600 tashimoto-support-font-medium tashimoto-support-text-sm"
    >
      {getInitials(alt)}
    </span>
  {/if}
</div>
